import get from "lodash/get";
import set from "lodash/set";
import { HEADER_AUTHORIZATION_TOKEN } from "service/base";
import io from "socket.io-client";
import { auth } from "store/auth";

const MGR_HEADER_PATH = "io.opts.transportOptions.polling.extraHeaders";

function genSocketHeaders(token) {
  return {
    transportOptions: {
      polling: {
        extraHeaders: getBearerToken(token),
      },
    },
  };
}

function getBearerToken(token) {
  return {
    [HEADER_AUTHORIZATION_TOKEN]: `Bearer ${token}`,
  };
}

function getSocketHeaders(socket) {
  return get(socket, MGR_HEADER_PATH, {});
}

function setSocketTokenHeaders(socket, token) {
  const oldHeaders = getSocketHeaders(socket);
  const extraHeaders = {
    ...oldHeaders,
    ...getBearerToken(token),
  };

  set(socket, MGR_HEADER_PATH, extraHeaders);
}

/**
 * Instantiate a SocketIO Client Connection
 *
 * @param {io} _io - Socket IO
 * @param {Auth} _auth - Auth Store
 *
 * @return {socket} - Socket IO client instance
 */
function getSocket(_io, _auth) {
  const token = _auth.getToken();
  const wsEnabled = true;

  return _io({
    path: "/socket.io",
    autoConnect: wsEnabled,
    reconnect: wsEnabled,
    ...genSocketHeaders(token),
  });
}

/**
 * Handle reconnect errors, and stop the connection attempt when the user
 * needs to authenticate.
 *
 * @param {Error} error - the reconnect error instance.
 */
function onReconnectError(error) {
  if (error.description === 401) {
    // eslint-disable-next-line no-invalid-this
    this.disconnect();
  }
}

const socket = getSocket(io, auth);
socket.on("reconnect_error", onReconnectError);

export { getSocketHeaders, MGR_HEADER_PATH, setSocketTokenHeaders, socket };
